__turbopack_context__.v({
  "typeform-embed": "WR0nJq_typeform-embed",
});
